import type { OrderFormItem } from '../../../../../core/requests/checkout'

// TODO: move this logic to sales-app-server after migrating simulation and orderForm apis
export const removeGiftItemsFromCartItemsList = (
  cartItems: Array<
    OrderFormItem & {
      index: number
    }
  >
) => {
  return cartItems.filter((item) => !item.isGift)
}
